import React from 'react';

interface PromptProps {
  prompt: string;
}

const Prompt = ({ prompt }: PromptProps) => {
  return (
    <div className="w-full rounded-24 border border-solid border-black bg-white px-36 py-10 shadow-[0_6px_10px_rgba(243,42,82,0.2)] sm:px-40 lg:px-[52px]">
      <p className="!m-0 !font-suisse-screen !text-byline-md text-black">{prompt}</p>
    </div>
  );
};

export default Prompt;
